import { render, staticRenderFns } from "./PreviewControls.vue?vue&type=template&id=0f966090&"
import script from "./PreviewControls.vue?vue&type=script&lang=js&"
export * from "./PreviewControls.vue?vue&type=script&lang=js&"
import style0 from "./PreviewControls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports